// extracted by mini-css-extract-plugin
export var inputWrapper = "textArea-module--inputWrapper--32YsL";
export var label = "textArea-module--label--1ZcE9";
export var input = "textArea-module--input--3ia0T";
export var error = "textArea-module--error--16UfT";
export var errorMessage = "textArea-module--errorMessage--11QKG";
export var required = "textArea-module--required--lS_H2";